/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useSetAtom } from 'jotai'
import { useHydrateAtoms } from 'jotai/utils'
import React, { useEffect } from 'react'

import { selectedCountryAtom } from '@/store/country'
import { selectedRegionAtom } from '@/store/region'
import { getCountryByCode } from '@/utils/countries'
import { DEFAULT_REGION, getRegionBySlug, getRepresentativeCountry } from '@/utils/regions'

/** A description of the available properties for this component. */
type RegionHydrationProps = {
  /** The region slug from the URL (e.g. 'en-gb', 'es', 'en-us'). */
  regionSlug: string
}

/**
 * Hydrates the selectedRegionAtom and selectedCountryAtom from the URL region slug.
 * The country is initialised to the region's representative country (e.g. en-eu → GB).
 * Syncs on prop changes to handle SPA navigations between regions.
 */
const RegionHydration: React.FC<RegionHydrationProps> = ({ regionSlug }) => {
  const region = getRegionBySlug(regionSlug) ?? DEFAULT_REGION
  const country = getCountryByCode(getRepresentativeCountry(region))

  const setSelectedRegion = useSetAtom(selectedRegionAtom)
  const setSelectedCountry = useSetAtom(selectedCountryAtom)

  useHydrateAtoms([
    [selectedRegionAtom, region],
    [selectedCountryAtom, country],
  ])

  // useHydrateAtoms only runs once per store, so it cannot track region changes on
  // a soft navigation (e.g. the header language switch). Without this sync the atoms
  // keep the previous region, and because the regional Link builds every href from
  // selectedRegionAtom, the whole page would link back into the region just left.
  useEffect(() => {
    setSelectedRegion(region)
    setSelectedCountry(country)
  }, [regionSlug, region, country, setSelectedRegion, setSelectedCountry])

  return null
}

export { RegionHydration }
